import BricksError from './BricksError';
class InvestorDoesNotExists extends BricksError {
    constructor(options) {
        super('The provided investor was not found', options);
    }
}
export default InvestorDoesNotExists;
